<template>
  <v-navigation-drawer
    v-if="!!postLaunchItem"
    right
    bottom
    absolute
    temporary
    width="30%"
    v-model="settingsDrawer"
  >
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            <v-card-title class="text-subtitle-2 text-h5">
              <v-icon
                color="primary"
              >
                mdi-cog-outline
              </v-icon>
              <v-spacer />
              {{ $t('dashboard.settings') }}
            </v-card-title>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider />
    <v-list
      nav
      dense
    >
      <v-list-item-group
        v-model="selectedItem"
        color="primary"
      >
        <v-list-item
          v-for="(item, i) in deviceStates"
          :key="`deviceStates-${i}`"
        >
          <v-list-item-content>
            <v-list-item-title v-text="item.name" />
          </v-list-item-content>
          <v-list-item-action>
            <v-checkbox
              v-model="item.value"
              dense
            />
          </v-list-item-action>
        </v-list-item>
        <v-divider />
        <v-list-item
          v-for="(item, i) in onlineStates"
          :key="`onlineStates-${i}`"
        >
          <v-list-item-content>
            <v-list-item-title v-text="item.name" />
          </v-list-item-content>
          <v-list-item-action>
            <v-checkbox
              v-model="item.value"
              dense
            />
          </v-list-item-action>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'DashSettings',
  data() {
    return {
      postLaunchItem: false,
      selectedItem: null,
    };
  },
  computed: {
    settingsDrawer: {
      get() {
        return this.$store.state.dashSettings;
      },
      set(bool) {
        this.$store.commit('setDashSettings', bool);
      },
    },
    deviceStates() {
      return [
        {
          name: this.$t('dashboard.low_battery'),
          value: true,
        },
        {
          name: this.$t('dashboard.transmitter_fault'),
          value: true,
        },
        {
          name: this.$t('dashboard.power_fault'),
          value: true,
        },
        {
          name: this.$t('dashboard.probe_fault'),
          value: true,
        },
      ];
    },
    onlineStates() {
      return [
        {
          name: this.$t('dashboard.online'),
          value: true,
        },
        {
          name: this.$t('dashboard.offline'),
          value: true,
        },
      ];
    },
  },
};
</script>

<style scoped>

</style>
